export const rootUrl = "https://censo.develotion.com/";

export const getJobs = (apiKey, id) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("apikey", apiKey);
  headers.append("iduser", id);
  // headers.append("apikey", "4171e00ddf882b0c971147a8fb2dce72");
  // headers.append("iduser", "6");

  // let urlencoded = new URLSearchParams();
  let reqConfig = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };

  return fetch(rootUrl + "ocupaciones.php", reqConfig)
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      if (result.codigo === 200) return result.ocupaciones;
      console.log("Ups, algo salió mal al obtener las ocupaciones");
      return [];
    })
    .catch((err) => console.log("error >>", err));
};

export const getDeptos = (apiKey, id) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("apikey", apiKey);
  headers.append("iduser", id);

  // let urlencoded = new URLSearchParams();
  let reqConfig = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };

  return fetch(rootUrl + "departamentos.php", reqConfig)
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      if (result.codigo === 200) return result.departamentos;
      return [];
    })
    .catch((err) => console.log("error >>", err));
};
export const getCities = (apiKey, id, idDepto) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("apikey", apiKey);
  headers.append("iduser", id);

  let reqConfig = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };
  return fetch(rootUrl + "ciudades.php?idDepartamento=" + idDepto, reqConfig)
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      if (result.codigo === 200) return result.ciudades;
      return [];
    })
    .catch((err) => console.log("error >>", err));
};

export const getPersonas = (apiKey, id) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("apikey", apiKey);
  headers.append("iduser", id);

  let reqConfig = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };
  return fetch(rootUrl + "personas.php?idUsuario=" + id, reqConfig)
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      if (result.codigo === 200) return result.personas;
      return [];
    })
    .catch((err) => console.log("error >>", err));
};
export const savePersona = (apiKey, id, newPersona) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("apikey", apiKey);
  headers.append("iduser", id);

  var rawData = JSON.stringify({
    idUsuario: id,
    nombre: newPersona.name,
    departamento: newPersona.dep,
    ciudad: newPersona.city,
    fechaNacimiento: newPersona.birthDayFormatted,
    ocupacion: newPersona.job,
  });
  let reqConfig = {
    method: "POST",
    headers: headers,
    body: rawData,
    redirect: "follow",
  };
  
  return fetch(rootUrl + "personas.php?idUsuario=" + id, reqConfig)
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      if (result.codigo === 200) return result;
      return [];
    })
    .catch((err) => console.log("error >>", err));
};
export const deletePersona = (apiKey, id, personId) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("apikey", apiKey);
  headers.append("iduser", id);

  let reqConfig = {
    method: "DELETE",
    headers: headers,
    redirect: "follow",
  };

  return fetch(rootUrl + "personas.php?idCenso=" + personId, reqConfig)
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      if (result.codigo === 200) return result;
      return [];
    })
    .catch((err) => console.log("error >>", err));
};

export const getTotalCenso = (apiKey, id) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("apikey", apiKey);
  headers.append("iduser", id);

  let reqConfig = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };


  return fetch(rootUrl + "totalCensados.php", reqConfig )
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      if (result.codigo === 200) return result.total;
      return [];
    })
    .catch((err) => console.log("error >>", err));
};
